<template>
  <d-container fluid class="user user-create-account main-content-container align-items-center justify-content-center">
    <d-col cols="12">
      <d-row class="justify-content-center">
        <d-col cols="8">
          <router-link class="nav-link px-0 d-inline-block" :to="{ name: 'order.index' }">
            &lt; {{ $t('button.go_back') }}
          </router-link>

          <h2 class="my-3">
            {{ $t('user.create_account.title') }}
          </h2>
        </d-col>

        <d-col cols="8">
          <account-form v-if="!hasAccount" />

          <d-card v-else>
            <d-card-body>
              <d-row>
                <d-col cols="12">
                  {{ $t('user.create_account.has_account') }}
                </d-col>
              </d-row>
            </d-card-body>
          </d-card>
        </d-col>
      </d-row>
    </d-col>
  </d-container>
</template>

<script>
import AccountForm from '@/components/user/AccountForm';
import { mapState } from 'vuex';

export default {
  name: 'user-create-account',
  components: { AccountForm },
  computed: {
    ...mapState('oneTimeUser', ['hasAccount']),
  },
}
</script>
